<template>
    <div>
        <div class="card mb-3" id="cost">
            <div class="card-header headline cost">
                <h2 class="text-white d-inline">هزینه</h2>
                <button class="btn btn-secondary float-left" data-toggle="modal" data-target="#cost-modal" @click="onModalButtonClicked">افزودن هزینه</button>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mb-3">
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                    </div>
                    <div class="col-lg-12 mt-5" v-if="costs.length < 1">
                        <h3 class="text-center no-item-alert">هزینه ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in costs">
                        <div class="card shadow pt-2 pb-2" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <div class="col-lg-12">
                                    <h5 class="text-center">{{item.outSourceName}}</h5>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="costs.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getcosts">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loading">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div v-if="!autoload && costs.length < dataCount" class="col-lg-12 text-center mb-3" @click="getcosts">
                        <button class="btn btn-success">نمایش موارد بیشتر</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="cost-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن هزینه</h5>
                        <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش هزینه</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">عنوان هزینه</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="cost.outSourceName">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger mr-2" v-if="params.mode === 'edit'" @click="deleteItem()" >حذف</button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(()=> {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'cost',
        components: {VsSelect},
        data() {
            return {
                costs: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    // parrentId: 8,
                    types: 8
                },
                cost: {
                    title: "",
                    // parrentId: 8,
                    type: 8
                },
                params: {
                    mode: 'create'
                },
                searchString: "",
                dataCount: 0,

                autoload: false,
                isSending: false,
            }
        } ,
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                this.costs = response.data.data;
                this.dataCount = response.data.count;
                $("#loading").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.costs.length < this.dataCount) {
                        $("#loading").show();
                        this.getcosts();
                    }
                });
            }
        },
        methods: {
            getcosts() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('outsource').getList(this.queryParams).then(response => {
                    this.costs.push.apply(this.costs, response.data.data);
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                $("#loading").show();
                new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                    this.costs = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(index) {
                this.params.mode = 'edit';
                this.cost = JSON.parse(JSON.stringify(this.costs[index]));
                $("#cost-modal").modal("show");
            },
            onModalButtonClicked() {
                this.params.mode = 'create';
                this.cost={
                    title: "",
                    // parrentId: 8,
                    type: 8
                };
                // this.cost.parrentId = 8;
                this.cost.type = 8;
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.cost);
                } else {
                    this.onUpdate(this.cost);
                }
            },
            onCreate(cost) {
                if(!this.isSending) {
                    this.isSending = true;
                    cost.rowVersion = this.generateUuid();
                    new BaseService('outsource').create(cost).then(response => {
                        this.$noty.success("هزینه با موفقیت افزوده شد.");
                        $("#cost-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                            this.costs = response.data.data;
                            $("#loading").hide();
                            Utils.resetObject(this.cost);
                            // this.cost.parrentId = 8;
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }
            },
            onUpdate(cost) {
                new BaseService('outsource').update(cost).then(response => {
                    this.$noty.success("هزینه با موفقیت ویرایش شد.");
                    $("#cost-modal").modal("hide");
                    this.queryParams.pageIndex = 0;
                    new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                        this.costs = response.data.data;
                        $("#loading").hide();
                        Utils.resetObject(this.cost);
                        // this.cost.parrentId = 8;
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            deleteItem(){
                if (confirm("آیا از حذف اطمینان دارید؟")) {
                    if (!this.isSending) {
                        this.isSending = true;
                        new BaseService('outsource').delete(this.cost.id).then(response => {
                            this.$noty.success("با موفقیت حذف شد.");
                            $("#cost-modal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                                this.costs = response.data.data;
                                $("#loading").hide();
                                Utils.resetObject(this.cost);
                                // this.cost.parrentId = 8;
                            }).catch(error => {
                                // error
                                Utils.handleErrorWithNotification(error.message, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            this.$noty.error(error.data.message);
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#cost-modal").hasClass("show")) {
                $("#cost-modal").modal("hide");
                next(false);
            } else {
                next();
            }
        },
    }
</script>